import { z } from "zod";

const FileAssetSource = z.object({
  assetId: z.string().uuid(),
  name: z.string(),
});

export type FileAssetSource = z.infer<typeof FileAssetSource>;

const UrlAssetSource = z.object({
  url: z.string().url(),
});

export type UrlAssetSource = z.infer<typeof UrlAssetSource>;

export const AssetSource = z.union([FileAssetSource, UrlAssetSource]);

export type AssetSource = z.infer<typeof AssetSource>;

export type AssetSourceType = "file" | "url";

export const Asset = z.object({
  source: AssetSource,
});

export type Asset = z.infer<typeof Asset>;

export const ImageAsset = Asset.extend({
  /**
   * "Native" pixel width and height of the image.
   * Not present in particular if the image is SVG.
   */
  width: z.number().optional(),
  height: z.number().optional(),
});

export type ImageAsset = z.infer<typeof ImageAsset>;

export const VideoAsset = Asset.extend({
  contentType: z.string().optional(),
  width: z.number().optional(),
  height: z.number().optional(),
  duration: z.number().optional(),
});

export type VideoAsset = z.infer<typeof VideoAsset>;

export const AudioAsset = Asset.extend({
  contentType: z.string().optional(),
  duration: z.number().optional(),
});

export type AudioAsset = z.infer<typeof AudioAsset>;
